import config from 'config';
import { AxiosResponse } from 'axios';
import { StatsResponse } from 'types/common';
import { SuccessResponse } from 'core/http/response';
import axiosClient from '../../config/axios';

export const getStatistics = async (): Promise<StatsResponse> => {
    const response: AxiosResponse<SuccessResponse<StatsResponse>> = await axiosClient.get(
        `${config.declarationsUrl}/declarations/statistic`
    );
    return response.data.payload;
};
